import { Component } from '@angular/core';

import { ThemeService } from '@library/common/branding';

@Component({
   selector: 'lib-terms',
   templateUrl: './terms.component.html',
})
export class TermsComponent {
   portal = document.title;

   constructor( public theme: ThemeService ) { }
}
